import Typography from '@shared/constants/Typography';
import {Platform, StyleSheet} from 'react-native';

export const createConfirmModalStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      backgroundColor: theme.indirectActivityModalOverlay,
    },
    modal: {
      backgroundColor: theme.notedModalBG,
      paddingHorizontal: Typography.padding.padding24,
      borderRadius: Typography.radius.radius8,
      minWidth: Typography.width.width512,
      maxWidth: Platform.OS === 'android' ?  Typography.width.width566: Typography.width.width549,
      //height: Typography.height.height312,
    },
    header: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.spaceBetween,
      alignItems: Typography.textAlign.centerAlign,
      paddingVertical: Typography.padding.padding20,
    },
    title: {
      fontSize: Typography.fontSize.fontSize24,
      fontWeight: Typography.fontWeight.semiBold,
      fontFamily: Typography.fontFamily.rethinkSans,
      color: theme.notedModalMainTitle,
      lineHeight: Typography.lineHeight.lineHeight36,
    },
    content: {
      //flex: 1,
      paddingVertical: Typography.padding.padding16,
    },
    errorMessageText: {
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize16,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.mandatoryIconColor,
      marginBottom: Typography.margin.margin32,
    },
    confirmationText: {
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize16,
      fontWeight: Typography.fontWeight.regular,
      color: theme.notedModalMainTitle,
      marginBottom: Typography.margin.margin12,
    },
    confirmationTextTwo: {
      marginTop: Typography.margin.margin8,
    },
    label: {
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.indirectActivityConfirmationText,
      textTransform: 'uppercase',
    },
    selectedActivityContainer: {
      borderWidth: 1,
      borderColor: theme.indirectActivitySelectedActivityBorder,
      borderRadius: Typography.radius.radius8,
      paddingHorizontal: Typography.padding.padding18,
      paddingTop: Typography.padding.padding18,
      paddingBottom: Typography.padding.padding2,
      gap: Typography.gap.gap12,
      height: Typography.height.height88,
      backgroundColor: theme.indirectActivitySelectedActivityBackground,
    },
    selectedActivityText: {
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize16,
      fontWeight: Typography.fontWeight.bold,
      color: theme.indirectActivitySelectedActivityText,
    },
    footerButtons: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      paddingVertical: Typography.padding.padding20,
    },
    rightContainer: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap16,
    },
    /** Fills space between additionalCTA (left) and changeCTA/confirmCTA (right) */
    footerSpacer: {
      flex: 1,
    },
    changeSelectionButton: {
      //backgroundColor: 'transparent',
      //borderColor: theme.changeSelectionBorder,
      borderWidth: Typography.borderWidth.borderWidth1,
    },
    changeSelectionButtonText: {
      //color: theme.cancelCTAText,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      fontFamily: Typography.fontFamily.inter,
    },
    confirmButton: {
      //backgroundColor: theme.listeningEnabledCTABG,
      //borderColor: theme.cancelCTABorder,
      borderWidth: Typography.borderWidth.borderWidth1,
    },
    confirmButtonText: {
      //color: theme.listeningEnabledCTAText,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      fontFamily: Typography.fontFamily.inter,
    },
    titleContainer: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap8,
    },
    iconContainer: {
      width: Typography.icon.icon24,
      height: Typography.icon.icon24,
      flexShrink: 0,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
    },
    closeButton: {
      // The CloseIcon SVG is 44px wide but the visible X only spans x=16–28,
      // leaving 16px of empty space on the right. Negative marginRight shifts
      // the icon right so the visual X aligns with the footer buttons' right edge.
      marginRight: -16,
    },
  });
